;(function( window, document, $, undefined ) {
	'use strict';

	// Typed Text

	function typedText() {

    // Animation
    function animation( $el ) {
      var text = $el.data('text');
      if(text) var text = text.split(",");
      $el.typed({
        strings: text,
        loop: true,
        typeSpeed: 40,
        backSpeed: 0,
        backDelay: 2000,
        fadeOut: true,
        fadeOutClass: 'typed-fade-out',
        //fadeOutDelay: 500
      });
    }

		// Globals
		return {
      animation: animation
		};

	}

	// Globals
	window.callsource = window.callsource || {};
  window.callsource.typedText = typedText();

})( window, document, jQuery );
